module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-angry.cb1fc74c.png";